/* eslint-disable no-use-before-define */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable wrap-iife */
G.Helpers = G.Helpers || {};

G.Helpers.candyDataMgr = (function () {
  let DATA = null;

  return {
    init,
    isTypeSpecial,
    getSpecialPatterns,
    getCombos,
    getSpecialData,
    getBaseData,
    getStatusData,
    getAllBaseTypes,
    getAllSpecialTypes,
    getAllStatuses,
    getBaseTypeByEditorSymbol,
    getSpecialTypeByEditorSymbol,
    getStatusByEditorSymbol,
    getTypesWithTag,
    getSpecialTypesWithTag,
    getTypesCombo,
  };

  function init(candyData) {
    DATA = candyData;
  }

  // TODO: replace, compability for now
  function getSpecialData(id) {
    return DATA.specialTypes.find(function (type) {
      return type.name === id;
    });
  }

  function getBaseData(id) {
    return DATA.baseTypes.find(function (type) {
      return type.id === id;
    });
  }

  function getStatusData(id) {
    return DATA.statuses.find(function (status) {
      return status.id === id;
    });
  }

  function getTypesWithTag(tag) {
    return DATA.baseTypes.filter(function (type) {
      return type.tags && type.tags.indexOf(tag) !== -1;
    });
  }

  function getSpecialTypesWithTag(tag) {
    return DATA.specialTypes.filter(function (type) {
      return type.tags && type.tags.indexOf(tag) !== -1;
    });
  }

  function getAllBaseTypes() {
    return DATA.baseTypes;
  }

  function getAllSpecialTypes() {
    return DATA.specialTypes;
  }

  function getAllStatuses() {
    return DATA.statuses;
  }

  function isTypeSpecial(id) {
    return Boolean(DATA.specialTypes.find(function (obj) {
      return obj.name === id;
    }));
  }

  function getBaseTypeByEditorSymbol(editorSymbol) {
    return DATA.baseTypes.find(function (obj) {
      return obj.editorSymbol === editorSymbol;
    });
  }

  function getSpecialTypeByEditorSymbol(editorSymbol) {
    return DATA.specialTypes.find(function (obj) {
      return obj.editorSymbol === editorSymbol;
    });
  }

  function getStatusByEditorSymbol(editorSymbol) {
    return DATA.statuses.find(function (obj) {
      return obj.editorSymbol === editorSymbol;
    });
  }

  function getCombos() {
    return G.Utils.defined(DATA.combos, []);
  }

  function getSpecialPatterns() {
    // TODO: replace with other format
    return DATA.specialTypes
      .filter(function (type) {
        return type.patterns;
      })
      .map(function (type) {
        return [type.name, type.patterns];
      });
  }
  
  function getTypesCombo(specialTypeA, specialTypeB) {
    return this.getCombos().find(([comboA, comboB]) => {
      return (
        (specialTypeA === comboA && specialTypeB === comboB) ||
        (specialTypeA === comboB && specialTypeB === comboA)
      );
    }) || null;
  }
})();
